/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Friend_Code_TitleInputs */

const en_mobile_referral_friend_code_title = /** @type {(inputs: Mobile_Referral_Friend_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friend’s code`)
};

const es_mobile_referral_friend_code_title = /** @type {(inputs: Mobile_Referral_Friend_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de un amigo`)
};

/**
* | output |
* | --- |
* | "Friend’s code" |
*
* @param {Mobile_Referral_Friend_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_friend_code_title = /** @type {((inputs?: Mobile_Referral_Friend_Code_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Friend_Code_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_friend_code_title(inputs)
	return en_mobile_referral_friend_code_title(inputs)
});